import script from "./block.vue?vue&type=script&lang=ts&setup=true"
export * from "./block.vue?vue&type=script&lang=ts&setup=true"

import "./block.vue?vue&type=style&index=0&id=a10a11f6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a10a11f6"]])

export default __exports__